<!-- // * ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
// *
// * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
// * and other pending or existing intellectual property rights in India, the United States and other countries. The Program
// * may contain / reference third party or open source components, the rights to which continue to remain with the applicable
// * third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
// * and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
// * form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or
// * otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
// * prosecuted to the maximum extent possible under the law. -->
<div class="example-container">
  <mat-table #table [dataSource]="dataSource" matSort>

    <!--<ng-container matColumnDef="select" >
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </mat-cell>
  </ng-container>-->


  @for (column of displayedColumns; track column) {
    <ng-container matColumnDef="{{column}}" >
      <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="{{alignments[column]==='right' ? 'before': 'after' }}"  [ngClass]="alignments[column]==='right'?{'align-right-header': true,'align-right-child': true}:'none'"> {{displayNames[column]}} </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="alignments[column]==='right'?'align-right-cell':'none'">
        <span >
          {{ column.indexOf('.') >= 0 ? element[column.split('.')[0]][column.split('.')[1]] : element[column] }}
        </span>
      </mat-cell>
    </ng-container>
  }

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></mat-row>
</mat-table>
@if (pageSize) {
  <mat-paginator #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [length] = "dataSourceSize"
    (page) = "setPageSize($event)">
  </mat-paginator>
}
</div>

